var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "mr-3",
    attrs: {
      "dense": "",
      "outlined": ""
    }
  }, [_vm._t("default"), _vm._l(_vm.editConfig, function (edit, index) {
    return _c('span', {
      key: JSON.stringify(edit) + index
    }, [edit.item === _vm.TemplateActionSpecialItemType.LINE ? _c('template-editor-action-divider') : edit.item === _vm.TemplateActionSpecialItemType.ADD_PLACEHOLDER ? _c('template-editor-add-placeholder', {
      attrs: {
        "partnerId": _vm.partnerId
      },
      on: {
        "addPlaceholder": _vm.addPlaceholder
      }
    }) : edit.content && edit.display.icon ? _c('v-btn', {
      attrs: {
        "icon": "",
        "disabled": !_vm.isActionButtonActive(edit.content)
      },
      on: {
        "click": function click($event) {
          return _vm.click(index, edit);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": _vm.menuStyleButtonColor(edit)
      }
    }, [_vm._v(_vm._s(edit.display.icon))])], 1) : edit.content && edit.display.text ? _c('v-btn', {
      staticClass: "ml-n3 mr-n3",
      attrs: {
        "text": "",
        "disabled": !_vm.isActionButtonActive(edit.content),
        "color": _vm.menuStyleButtonColor(edit)
      },
      on: {
        "click": function click($event) {
          return _vm.click(index, edit);
        }
      }
    }, [_c('small', [_vm._v(_vm._s(edit.display.text))])]) : edit.content && edit.display.color ? _c('v-btn', {
      staticStyle: {
        "margin-left": "-6px",
        "margin-right": "-6px"
      },
      attrs: {
        "icon": "",
        "disabled": !_vm.isActionButtonActive(edit.content)
      },
      on: {
        "click": function click($event) {
          return _vm.click(index, edit);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": edit.display.color
      }
    }, [_vm._v("mdi-square-rounded")])], 1) : _vm._e(), edit.sublist ? _c('v-btn', {
      staticStyle: {
        "overflow": "none"
      },
      attrs: {
        "icon": "",
        "color": _vm.menuSublistButtonColor(edit)
      },
      on: {
        "click": function click($event) {
          return _vm.click(index, edit);
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "position": "relative",
        "left": "12px",
        "bottom": "2px"
      },
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(edit.display.icon))]), _vm.isActiveSublist(edit.sublist) ? _c('v-icon', {
      staticStyle: {
        "position": "relative",
        "right": "12px",
        "top": "9px"
      },
      attrs: {
        "x-small": ""
      }
    }, [_vm._v(" mdi-chevron-up ")]) : _c('v-icon', {
      staticStyle: {
        "position": "relative",
        "right": "12px",
        "top": "10px"
      },
      attrs: {
        "x-small": ""
      }
    }, [_vm._v(" mdi-chevron-down ")])], 1) : _vm._e()], 1);
  })], 2), _vm.sublist.length ? _c('v-row', [_c('v-spacer'), _c('template-editor-actions', {
    ref: "sublist",
    staticClass: "mt-2",
    staticStyle: {
      "position": "absolute",
      "z-index": "1",
      "right": "7px"
    },
    style: "margin-right: ".concat(_vm.sublistSpacing * 34 + 6, "px"),
    attrs: {
      "editConfig": _vm.sublist,
      "root": false,
      "editor": _vm.editor,
      "partnerId": _vm.partnerId
    },
    on: {
      "click": _vm.bubbleClick,
      "addPlaceholder": _vm.addPlaceholder
    }
  })], 1) : _vm._e(), _vm.root ? _c('v-row', [_c('public-image-upload-dialog', {
    ref: "publicImageUploadDialog",
    attrs: {
      "folder": _vm.folderName,
      "hideButton": true
    },
    on: {
      "onUpload": _vm.upload
    }
  }), _c('template-dialog-paste-url', {
    ref: "pasteImageDialog",
    on: {
      "onInput": _vm.paste
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }